import React from "react"
import InsuranceDetails from "components/insurance-details"
import { InsuranceDetailsProvider } from "components/insurance-details/context/useInsuranceDetails"
import { CenteredLayout } from "components/views/atoms/Layouts"
import { PageHeader } from "components/views/molecules/Molecules"
import { ReimbursementStatusProvider } from "components/context/reimbursement/ReimbursementStatusContext"
import { Container } from "@carrotfertility/carotene"
import { MasterLayout } from "components/views/atoms/layouts/MasterLayout"
import { DeductibleProvider } from "components/context/user/DeductibleContext"

const InsuranceHeader = (): JSX.Element => <PageHeader icon="icn-insurance" title={`Insurance Details`} />

const InsuranceDetailsPage = (): JSX.Element => {
  return (
    <MasterLayout header={<InsuranceHeader />}>
      <CenteredLayout>
        <DeductibleProvider>
          <InsuranceDetailsProvider>
            <ReimbursementStatusProvider>
              <Container sx={{ paddingBottom: "64px" }} width="685px">
                <InsuranceDetails />
              </Container>
            </ReimbursementStatusProvider>
          </InsuranceDetailsProvider>
        </DeductibleProvider>
      </CenteredLayout>
    </MasterLayout>
  )
}

export default InsuranceDetailsPage
